module.exports = __webpack_public_path__ + "static/img/3919_phase_function_Paper_Points.c651fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3919_phase_function_Paper_Points.png
// module id = 8eVV
// module chunks = 0